import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=3be0f96d&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0f96d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be0f96d')) {
      api.createRecord('3be0f96d', component.options)
    } else {
      api.reload('3be0f96d', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=3be0f96d&scoped=true", function () {
      api.rerender('3be0f96d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/Editor.vue"
export default component.exports